import { inject } from '@angular/core'
import { CanActivateFn, Router } from '@angular/router'
import { GroupType } from '@mattrika/benefit-model'
import { AuthStateService } from '../auth/auth-state.service'

export function publicGuard(): CanActivateFn {
    return () => {
        const authStateService = inject(AuthStateService)
        const router = inject(Router)

        if (authStateService.isLoggedIn()) {
            const groupType = authStateService.getGroupType()

            if (
                authStateService.isSuperAdmin() ||
                groupType === GroupType.superAdmin
            ) {
                return router.createUrlTree(['/admin'])
            }
            if (groupType === GroupType.vendor) {
                return router.createUrlTree(['/vendor'])
            }
            if (groupType === GroupType.client) {
                return authStateService.isOwner()
                    ? router.createUrlTree(['/client-admin'])
                    : router.createUrlTree(['/'])
            }

            return router.createUrlTree(['/'])
        }

        return true
    }
}
